import { Layers } from 'lucide-react';

/**
 * 'Auto-mix rounds' — ON means a rounds block over 5 minutes is split across
 * 2-3 movements; OFF keeps only the movement the user chose.
 */
export function AutoMixToggle({ value, onChange, testId = 'auto-mix-toggle' }) {
  return (
    <button
      type="button"
      onClick={() => onChange(!value)}
      className={`w-full flex items-center gap-3 rounded-xl border p-3 text-left transition-colors ${
        value ? 'bg-accent/10 border-accent/40' : 'bg-white/[0.03] border-white/10'
      }`}
      data-testid={testId}
      aria-pressed={value}
    >
      <span
        className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center border ${
          value ? 'bg-accent/20 border-accent/40 text-accent' : 'bg-black/40 border-white/10 text-white/35'
        }`}
      >
        <Layers size={14} strokeWidth={2.5} />
      </span>
      <span className="flex-1 min-w-0">
        <span className="block font-heading text-sm uppercase tracking-wider text-white">
          Auto-mix rounds
        </span>
        <span className="block text-xs text-white/45 mt-0.5">
          {value
            ? 'Longer rounds sessions split across 2-3 movements'
            : 'One movement for the whole block'}
        </span>
      </span>
      <span
        className={`relative w-11 h-6 shrink-0 rounded-full transition-colors ${
          value ? 'bg-accent' : 'bg-white/15'
        }`}
        data-testid={`${testId}-switch`}
      >
        <span
          className={`absolute top-0.5 w-5 h-5 rounded-full bg-black transition-all ${
            value ? 'left-[22px]' : 'left-0.5 bg-white/70'
          }`}
        />
      </span>
    </button>
  );
}
